import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';

const Abouts = [
  {
    title: "Responsive Web Design",
    description: `I can build a responsive web design for all monitors`,
    imgUrl:images.about01
  },
  {
    title: "Amazing Design",
    description: `I will help you to make your busniss website with Beautfull UI/UX design`,
    imgUrl:images.about02
  },
  {
    title: "Speed Access",
    description: `I will upload your website on fastest host and simple domain name`,
    imgUrl:images.about03
  }
]

const About = () => {
  /* const [abouts, setAbouts] = useState([]);
  setAbouts(Abouts) */
  

  return (
    <>
      <h2 className="head-text">I Know that <span>Good Design</span> <br />means  <span>Good Business</span></h2>

      <div className="app__profiles">
        {Abouts.map((about) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title}
          >
            <img src={about.imgUrl} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}> {about.title} </h2>
            <p className="p-text" style={{ marginTop: 10 }}> {about.description} </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
  